
















import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";

import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    CommonHeading,
    IconBase
  }
})
export default class A01PanelHeadingTitle extends Vue {
  @Prop({
    type: String,
    required: true
  })
  title!: string;
}
